import React, { useState, useEffect } from 'react'

import { UploadOutlined } from '@ant-design/icons'

import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'

import { Button, Card, Input, Modal, Row, Col, notification, Spin, Upload, message } from 'antd'
import axios from 'axios'

import { filterTable } from '@/search'
import { Can, Say } from '../../components/can'
import appConfig from '../../config'
import apiErrorHandler from '../../api-error-handler'
import EditTable from '../../components/EditTable'
import _ from 'lodash'
import qs from 'querystring'

const rateProgramUrl = `${appConfig.apiUrl}/hotel/marriott/rate-program`
const RESOURCE = 'hotel-marriott'

const columns = [
    {
        key: 'hotel_id',
        dataIndex: 'hotel_id',
        title: 'Hotel ID'
    },
    // {
    //     key: 'marsha',
    //     dataIndex: 'marsha',
    //     title: 'MARSHA'
    // },
    // {
    //     key: 'marsha_chain_code',
    //     dataIndex: 'marsha_chain_code',
    //     title: 'MARSHA\nCHAIN CODE'
    // },
    // {
    //     key: 'gds_dwp_chain_code',
    //     dataIndex: 'gds_dwp_chain_code',
    //     title: 'GDS/DWP\nChain Code'
    // },
    // {
    //     key: 'dhisco_chain_code',
    //     dataIndex: 'dhisco_chain_code',
    //     title: 'DHISCO\nChain Code'
    // },
    {
        key: 'property_name',
        dataIndex: 'property_name',
        title: 'PROPERTY NAME'
    },
    {
        key: 'marriott_cluster_code',
        dataIndex: 'marriott_cluster_code',
        title: 'Marriott Rate Code (Cluster Code)'
    },
    {
        key: 'ro_bb_for_2ad',
        dataIndex: 'ro_bb_for_2ad',
        title: 'Room Only /Breakfast for 2 AD'
    },
    {
        key: 'rate_program',
        dataIndex: 'rate_program',
        title: 'RATE PROGRAM'
    },
    {
        key: 'roompool',
        dataIndex: 'roompool',
        title: 'ROOMPOOL'
    },
    {
        key: 'roompool_name',
        dataIndex: 'roompool_name',
        title: 'Room Pool Name'
    },
    {
        key: 'maximum_occupancy',
        dataIndex: 'maximum_occupancy',
        title: 'Maximum Occupancy\nusing existing bedding in the room'
    },
    {
        key: 'extra_person_fee',
        dataIndex: 'extra_person_fee',
        title: 'Extra Person Fee\nall extra person charges are paid at property'
    },
    // {
    //     key: 'extra_person_fee_indicators',
    //     dataIndex: 'extra_person_fee_indicators',
    //     title:
    //         'Extra Person Fee Indicators\nTE = Fee Excluded & Taxable\nP = per Person\nP3 = start on 3rd person\nR = per Room\nN = per Night\nM = Max Number NTS to Charge'
    // },
    // {
    //     key: 'extra_person_fee_age',
    //     dataIndex: 'extra_person_fee_age',
    //     title: 'Extra Person Fee Age'
    // },
    {
        key: 'resort_fee',
        dataIndex: 'resort_fee',
        title: 'Resort Fee\nall resort fees are paid at property'
    }
    // {
    //     key: 'resort_fee_indicators',
    //     dataIndex: 'resort_fee_indicators',
    //     title:
    //         'Resort Fee Indicators\nE = Excluded\nTE/TEX = Fee Excluded & Taxable\nI = Included\nP = per Person\nP3 = start on 3rd person\nR = per Room\nN = per Night\nS = per Stay\nM = Max Number NTS to Charge'
    // },
    // {
    //     key: 'destination_amenity_fee',
    //     dataIndex: 'destination_amenity_fee',
    //     title: 'Destination Amenity Fee'
    // },
    // {
    //     key: 'destination_amenity_indicators',
    //     dataIndex: 'destination_amenity_indicators',
    //     title:
    //         'Destination Amenity Indicators\nE = Excluded\nTE/TEX = Fee Excluded & Taxable\nI = Included\nP = per Person\nP3 = start on 3rd person\nR = per Room\nN = per Night\nS = per Stay\nM = Max Number NTS to Charge'
    // },
    // {
    //     key: 'currency',
    //     dataIndex: 'currency',
    //     title: 'Currency'
    // },
    // {
    //     key: 'address',
    //     dataIndex: 'address',
    //     title: 'ADDRESS'
    // },
    // {
    //     key: 'city',
    //     dataIndex: 'city',
    //     title: 'CITY'
    // },
    // {
    //     key: 'physical_state_province',
    //     dataIndex: 'physical_state_province',
    //     title: 'Physical State/Province'
    // },
    // {
    //     key: 'zipcode',
    //     dataIndex: 'zipcode',
    //     title: 'ZIPCODE'
    // },
    // {
    //     key: 'physical_country_region',
    //     dataIndex: 'physical_country_region',
    //     title: 'Physical Country/Region'
    // },
    // {
    //     key: 'property_opening_status',
    //     dataIndex: 'property_opening_status',
    //     title: 'Property Opening Status'
    // },
    // {
    //     key: 'opening_date_for_new_hotels',
    //     dataIndex: 'opening_date_for_new_hotels',
    //     title: 'Opening Date for New Hotels'
    // },
    // {
    //     key: 'exceptions',
    //     dataIndex: 'exceptions',
    //     title: 'EXCEPTIONS'
    // }
]

function MarriottRateProgram() {
    const [loading, setLoading] = useState(true)
    const [initialRates, setInitialRates] = useState([])
    const [rates, setRates] = useState([])
    const [showImportRate, setShowImportRate] = useState(false)
    const headers = JSON.parse(localStorage.getItem('headers') || '{}')
    const [filter, setFilter] = useState({})

    useEffect(() => {
        getRates()
    }, [])

    const getRates = () => {
        const config = { method: 'get', url: rateProgramUrl, headers }
        if (!_.isEmpty(filter)) {
            config.url += `?${qs.stringify(filter)}`
        }

        axios(config)
            .then(({ data }) => {
                setRates(data)
                setInitialRates(data)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
                notification.error({
                    message: 'Error!!!',
                    description: apiErrorHandler(error)
                })
            })
    }

    const updateRate = row => {
        setLoading(true)
        axios({
            method: 'patch',
            url: `${rateProgramUrl}/${row.pair}`,
            headers,
            data: {
                rate: Number(row.rate)
            }
        })
            .then(() => {
                getRates()
            })
            .catch(error => {
                notification.error({
                    message: 'Error!!!',
                    description: apiErrorHandler(error)
                })
                getRates()
            })
    }

    const toggleImportRate = () => {
        setShowImportRate(!showImportRate)
    }

    const onSearch = e => {
        const searchInput = e.target.value
        const rates = filterTable(searchInput, initialRates, columns)
        setRates(rates)
    }

    const onChangeHotelId = e => {
        const hotelId = e.target.value
        if (hotelId) {
            const newFilter = Object.assign(filter, { hotel_id: hotelId })
            setFilter(newFilter)
        } else {
            delete filter.hotel_id
        }
    }

    const onChangeClusterCode = e => {
        const clusterCode = e.target.value
        if (clusterCode) {
            const newFilter = Object.assign(filter, { marriott_cluster_code: clusterCode })
            setFilter(newFilter)
        } else {
            delete filter.marriott_cluster_code
        }
    }

    return (
        <div>
            <Card gutter={16}>
                <Row gutter={16}>
                    <Col md={8}>
                        <Input placeholder="Hotel Id (MC-PAROA)" onChange={onChangeHotelId} />
                    </Col>
                    <Col md={8}>
                        <Input placeholder="Marriott Cluster Code (DN2)" onChange={onChangeClusterCode} />
                    </Col>
                    <Col md={8}>
                        <Button type="primary" onClick={getRates}>
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Card>
            <br />
            <Card>
                <Row>
                    <Col md={16}>
                        <Can resource={RESOURCE} perform={'create'}>
                            <Say yes>
                                <Button className="ml-2" type="success" onClick={toggleImportRate}>
                                    <UploadOutlined /> Upload Rate Programs
                                </Button>
                            </Say>
                        </Can>
                    </Col>
                    <Col md={8}>
                        <Input placeholder="Search" onChange={onSearch} />
                    </Col>
                </Row>
                <br />
                <Spin spinning={loading}>
                    <EditTable rowKey="pair" bordered dataSource={rates} columns={columns} handleSave={updateRate} />
                </Spin>
            </Card>

            <ImportCSV isShow={showImportRate} toggle={toggleImportRate} onSuccess={getRates} />
        </div>
    )
}

function ImportCSV({ onSuccess, isShow, toggle }) {
    const headers = JSON.parse(localStorage.getItem('headers') || '{}')

    const onChange = info => {
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`)
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`)
        }
    }

    const excuteImport = () => {
        onSuccess()
        toggle()
    }

    return (
        <Modal
            visible={isShow}
            title="Import Rate Programs"
            onOk={excuteImport}
            onCancel={toggle}
            style={{ maxWidth: '70%' }}>
            <div className="mb-2 row">
                <div className="col-md-9">
                    <Upload name="file" multipart={true} action={rateProgramUrl} headers={headers} onChange={onChange}>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </div>
            </div>

            {/* <Table rowKey="line" bordered dataSource={csvData} columns={columns} /> */}
        </Modal>
    )
}

export default Form.create({ name: 'marriott-rate-program' })(MarriottRateProgram)
